import { render } from "./ActivityDetail.vue?vue&type=template&id=2295525e&ts=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=ts"
export * from "./ActivityDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__